// PDF.js worker URL. Use a CDN so the worker loads reliably in production (bundler asset URLs
// often fail with "Failed to fetch dynamically imported module" due to path/MIME/CORS).
// Version must match pdfjs-dist in package.json.
const PDFJS_WORKER_VERSION = '5.4.624';
export const pdfjsWorkerSrc = `https://unpkg.com/pdfjs-dist@${PDFJS_WORKER_VERSION}/build/pdf.worker.min.mjs`;

